import { defineMessages } from 'react-intl';

export default defineMessages({
    company: {
        id: 'gateway.contacts.components.CustomContactDetailsCompany.Organization ',
        defaultMessage: 'Organization ', // DE16978
    },
    officePhone: {
        id: 'gateway.contacts.components.CustomContactDetailsCompany.OfficePhone',
        defaultMessage: 'Office Phone',
    },
    fax: {
        id: 'gateway.contacts.components.CustomContactDetailsCompany.Fax',
        defaultMessage: 'Fax',
    },
    companyPrimaryEmail: {
        id: 'gateway.contacts.components.CustomContactDetailsCompany.PrimaryEmail',
        defaultMessage: 'Primary Email',
    },
    companyAddress: {
        id: 'gateway.contacts.components.CustomContactDetailsCompany.Address',
        defaultMessage: 'Address',
    },
    person: {
        id: 'gateway.contacts.components.CustomContactDetailsPerson.Person',
        defaultMessage: 'Person',
    },
    dateOfBirth: {
        id: 'gateway.contacts.components.CustomContactDetailsPerson.Date of Birth',
        defaultMessage: 'Date of Birth',
    },
    maritaStatus: {
        id: 'gateway.contacts.components.CustomContactDetailsPerson.Marital Status',
        defaultMessage: 'Marital Status',
    },
    homePhone: {
        id: 'gateway.contacts.components.CustomContactDetailsPerson.home',
        defaultMessage: 'Home Phone',
    },
    homePhonePrimary: {
        id: 'gateway.contacts.components.CustomContactDetailsPerson.home primary',
        defaultMessage: 'Home Phone (primary)',
    },
    workPhone: {
        id: 'gateway.contacts.components.CustomContactDetailsPerson.work',
        defaultMessage: 'Work Phone',
    },
    workPhonePrimary: {
        id: 'gateway.contacts.components.CustomContactDetailsPerson.work primary',
        defaultMessage: 'Work Phone (primary)',
    },
    mobile: {
        id: 'gateway.contacts.components.CustomContactDetailsPerson.mobile',
        defaultMessage: 'Mobile',
    },
    mobilePrimary: {
        id: 'gateway.contacts.components.CustomContactDetailsPerson.mobile primary',
        defaultMessage: 'Mobile (primary)',
    },
    personPrimaryEmail: {
        id: 'gateway.contacts.components.CustomContactDetailsPerson.Primary Email',
        defaultMessage: 'Primary Email',
    },
    personAddress: {
        id: 'gateway.contacts.components.CustomContactDetailsPerson.Address',
        defaultMessage: 'Address',
    },
    roles: {
        id: 'gateway.contacts.components.CustomContactDetails.Roles.Title',
        defaultMessage: 'Roles',
    },
    associatedAccounts: {
        id: 'gateway.contacts.components.CustomContactDetails.Associated Accounts',
        defaultMessage: 'Associated Accounts',
    },
});
